import { faReply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import ResponderDuvidaTecnica from "../../ResponderDuvidaTecnica";
import { IComponentModal } from "../../../../../../Components/Modais/IModalComponent";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IAcoesAcessoUsuario } from "../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";

interface IBotaoDuvidaTecnicaProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    AcaoAcessoUsuario: IAcoesAcessoUsuario[] | undefined;
}

export default function BotaoResponderDuvidaTecnica(
    props: IBotaoDuvidaTecnicaProps
) {
    const { Atendimento } = useAtendimentoPage();

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;
    return (
        <button
            type="button"
            className="btn btn-sm btn-primary m-1"
            onClick={() => {
                props.setShow(true);
                props.setModal({
                    headerComponent: "Responder Dúvida Técnica",
                    IconHeader: faReply,
                    Component: () => (
                        <ResponderDuvidaTecnica setShow={props.setShow} />
                    ),
                    size: "lg",
                });
            }}
            disabled={
                !props.AcaoAcessoUsuario?.find(
                    (acaoFiltrada) => acaoFiltrada.ID_ACAO === 22
                )?.FL_USUARIO_ACESSA ||
                AtendimentoDetalhado.FL_SINCRONIZADO === false
            }
        >
            <FontAwesomeIcon icon={faReply} className="mr-2" />
            Responder Vistoria Inconclusiva
        </button>
    );
}
